import React from 'react'
import classes from '@/components/DeployButton/DeployButton.module.scss'
import Typography from '@/components/ui/Typography'
import Input from '@/components/ui/Input'
import CopyAdornment from '@/components/ui/CopyAdornment'
import { useRouteEntryPoint } from '@/hooks/useRouteEntryPoint'

export type MailDeployInstructionsProps = { projectId: number; routeId: number }

const MailDeployInstructions = ({ projectId, routeId }: MailDeployInstructionsProps) => {
  const email = useRouteEntryPoint(projectId, routeId)

  return (
    <div className={classes.mailRoot}>
      <Typography>1. Copy the email address below and use it as the recipient to call the route:</Typography>
      <Input value={email} disabled endAdornment={<CopyAdornment value={email} />} />
    </div>
  )
}

export default MailDeployInstructions
